import { useSearchParams } from 'react-router-dom';

/**
 * True when the current route is rendered inside an embedding host (iframe) via
 * the `?embed=1` query flag — e.g. the SmartVault "View as Folders" modal in the
 * legacy Files page. Consumers use it to drop the global app chrome
 * (sidebar/header) so the page renders standalone in the host.
 */
export const useEmbedMode = (): boolean => {
  const [searchParams] = useSearchParams();
  return searchParams.get('embed') === '1';
};
